import React, { Component } from 'react';
import { Link } from 'react-router';

class GalleryMenu extends Component {
  render() {
    return (
      <nav className="gallery-menu">
        <Link activeClassName="selected" to="/gallery/IKEA">IKEA</Link>
        <Link activeClassName="selected" to="/gallery/furniture">Furniture</Link>
        {/* <Link activeClassName="selected" to="/gallery/kitchen">Kitchens</Link> */}
      </nav>
    );
  }
}
export default GalleryMenu;



// WEBPACK FOOTER //
// ./src/components/GalleryMenu.js